/* eslint-disable class-methods-use-this */
import { EnvironmentManager } from './envManager';
import type { URLManager } from './urlManager';

export default class URLManagerImpl implements URLManager {
  envManager: EnvironmentManager;

  constructor(envManager: EnvironmentManager) {
    this.envManager = envManager;
  }

  get base(): string {
    if (this.envManager.isProductionEnv) {
      return 'https://soundtracks.loudly.com';
    }
    if (this.envManager.isStagingEnv) {
      return 'https://soundtracks-stg.loudly.com';
    }
    return 'https://soundtracks-dev.loudly.com/';
  }

  get homepage(): string {
    return `/music`;
  }

  get iubenda(): string {
    return 'https://consent.iubenda.com';
  }

  get search(): string {
    if (this.envManager.isProductionEnv) {
      return 'https://search.loudly.com';
    }
    if (this.envManager.isStagingEnv) {
      return 'https://search-stg.loudly.com';
    }
    return 'https://search-dev.loudly.com';
  }
}
